import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  MenuItem,
  Select,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import AddCardIcon from "@mui/icons-material/AddCard";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import PaymentsIcon from "@mui/icons-material/Payments";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { SiTether } from "react-icons/si";
import Preloader from "../components/Preloader";
import {
  calculateTotalCurrencyAmount,
  getCurrencyCode,
  handleLogout,
  moneyFormat,
} from "../utils/utils";
import { useWallet } from "../api/hooks/useWallet";
import { getOrganizationSettings } from "../utils/storage";
import LoanCard from "../components/loanProductCard";
import CustomButton from "../components/customButton";
import LoanStepper from "../components/loanStepper";
import { useLoanProducts } from "../api/hooks/useLoan";

const BookLoan = () => {
  const [selectedLoan, setSelectedLoan] = useState();
  const [balance, setBalance] = useState(0);
  const [wallets, setWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState("");

  const navigate = useNavigate()


  const { isLoading: isWalletLoading, data: walletsData } = useWallet();


  useEffect(() => {
    if (!walletsData) return;

    if (walletsData.data?.length > 0 || walletsData.data?.length > 0) {
      let walletsArr = walletsData?.data || [];

      walletsArr = walletsArr.filter((wallet) => wallet.currency.code == "NGN");

      setWallets(walletsArr);

      setSelectedWallet(
        walletsArr[0]?.wallet_number || walletsArr[0]?.id || ""
      );
    }
  }, [walletsData]);

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <header className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold text-gray-800">Book a Loan</h1>

        <CustomButton label={"My Loans"} fullWidth={false} onPress={() => { navigate('/loan-center') }} />

      </header>

      <LoanStepper />

    </div>
  );
};

export default BookLoan;